import * as React from 'react';
import * as PropTypes from 'prop-types';
import { Wrapper, TextWrapper, Name, Icon, TimeLabel } from './elements';
import Ava36 from 'dc/Ava36';

type APH120Props = {
  className?: string;
  onClick?: () => void;
  avatar?: string;
  isLoadingAvatar?: boolean;
  name: string;
  labelIcon?: string;
  time: string;
  icon?: string;
  iconColor?: string;
};

function APH120(props: APH120Props): React.ReactElement {
  return (
    <Wrapper className={props.className} onClick={props.onClick}>
      <Ava36 image={props.avatar} isLoading={props.isLoadingAvatar} />
      <TextWrapper>
        <Name>{props.name}</Name>
        <TimeLabel
          color={'#546e7a'}
          icon={props.labelIcon ? props.labelIcon : 'icon-schedule'}
        >
          {props.time}
        </TimeLabel>
      </TextWrapper>
      <Icon icon={props.icon} color={props.iconColor || '#607D8B'} />
    </Wrapper>
  );
}

APH120.propTypes = {
  avatar: PropTypes.string,
  className: PropTypes.string,
  icon: PropTypes.string,
  iconColor: PropTypes.string,
  labelIcon: PropTypes.string,
  isLoadingAvatar: PropTypes.bool,
  name: PropTypes.string,
  onClick: PropTypes.func,
  time: PropTypes.node,
};
export default APH120;
